import React from "react";
import dayjs from "dayjs";
import MUIDataTable from "../../../components/MUIGrid";
import DOMPurify from "dompurify";
const TaskInfoModal = ({ taskData, backlinksTypeList }) => {
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 100,
    page: 1,
  });

  function convertUrlsToLinks(text) {
    const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    return text.replace(urlPattern, (url) => {
      const fullUrl = url.startsWith("www.") ? `https://${url}` : url;

      return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer" style="color:#0051c3">${url}</a>`;
    });
  }

  const columns = [
    { field: "counter", headerName: "Sr#", width: 10, filterable: false },
    {
      field: "name",
      headerName: "Assigned To",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "backlink_name",
      headerName: "Backlink",
      width: 150,
      hideable: false,
      renderCell: (params) => {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://${params?.value}`}
            className="text-black no-underline hover:underline cursor-poi"
          >
            {params?.value}
          </a>
        );
      },
    },
    {
      field: "backlink_type",
      headerName: "Backlink Type",
      minWidth: 100,
      flex: 1,
      type: "singleSelect",
      valueOptions: backlinksTypeList?.map((item) => item.type),
      renderCell: (params) => params.value,
      align: "center",
    },
    {
      field: "task_status",
      headerName: "Current Task Status",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => (
        <span className="capitalize">{params.value}</span>
      ),
    },
    {
      field: "link_to_website",
      headerName: "Live URL",
      hideable: false,
      renderCell: (params) => {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${params?.value}`}
            className="text-black no-underline hover:underline cursor-poi"
          >
            {params?.value}
          </a>
        );
      },
      flex: 1,
      minWidth: 180,
    },
    {
      field: "latest_hold_reason",
      headerName: "Latest Hold Reason",
      minWidth: 230,
      align: "center",
      renderCell: (params) => {
        const content =
          params?.row?.hold_reason && params?.row?.hold_reason !== null
            ? params?.row?.hold_reason
            : "NA";

        const contentWithLinks = convertUrlsToLinks(content);

        const sanitizedContent = DOMPurify.sanitize(contentWithLinks, {
          ALLOWED_ATTR: ["href", "target", "rel", "style", "class"],
        });

        return (
          <>
            {params?.row?.latest_hold_reason &&
            params?.row?.latest_hold_reason !== null ? (
              <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                {params?.row?.latest_hold_reason || "NA"}
              </div>
            ) : (
              <div className="whitespace-normal break-words max-h-40 overflow-auto p-2 ">
                {/* Use dangerouslySetInnerHTML to render the sanitized HTML */}
                <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "assigned_date",
      headerName: "Assigned Date",
      width: 200,
      editable: false,
      filterable: false,
      renderCell: (params) => <div>{params.row.assigned_date}</div>,
    },
  ];
  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
  };

  const getRowHeight = (params) => {
    const rowHeight = 40;
    const cellContentHeight = 0;

    const data = params?.model;

    const content = data?.latest_hold_reason || data?.hold_reason || "";

    const numberOfReasonLines = Math.ceil(content.length / 50);

    const reasonHeight = rowHeight + numberOfReasonLines * 24;

    return Math.max(reasonHeight, rowHeight + cellContentHeight);
  };

  return (
    <MUIDataTable
      columnDefs={columns}
      items={(taskData?.length ? taskData : [])?.map((record, index) => {
        const {
          name,
          backlink_name,
          assigned_date,
          link_to_website,
          backlink_type,
          task_status,
          latest_hold_reason,
          hold_reason,
        } = record;
        const formattedAssignedDate = assigned_date
          ? dayjs(assigned_date).format("ddd, MMM D, YYYY h:mm A")
          : "-";
        return {
          counter: index + 1,
          name,
          backlink_name,
          assigned_date: formattedAssignedDate,
          link_to_website,
          backlink_type,
          task_status,
          latest_hold_reason,
          hold_reason,
        };
      })}
      totalItems={taskData?.length}
      height="75vh"
      paginationModel={paginationModel}
      searchable="No"
      showCount="No"
      sortingMode="client"
      paginationMode="client"
      onPaginationModelChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
      filterMode="client"
      gridOptions={getRowHeight}
    />
  );
};

export default TaskInfoModal;
